import React, { Component } from "react";
import moment from "moment";
import { graphql, Query } from "react-apollo";

import {
  getFrequences,
  getPrevisionnel
} from "../../api/queries/transactions.queries";
import ValidatedRegisterForm from "../components/ValidatedRegisterForm";
import WrappedUp from "../containers/WrappedUp";
import AccountList from "../components/AccountList";
import Loader from "../components/Loader";
import TableFrequences from "../tables/TableFrequences";
import prepareFrequenceDataByWeek from "../../functions/frequences";

class DebugPage extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <WrappedUp>
        <h1 className="dashboardTitle">Debug</h1>
        <Query
          query={getFrequences}
          variables={{ utilisateurId: 32 }}
          fetchPolicy="no-cache"
        >
          {({ loading, error, data = {}, refetch }) => {
            if (loading) return <Loader />;
            if (error) return "Erreur";

            return (
              <Query
                query={getPrevisionnel}
                variables={{ utilisateurId: 32 }}
                fetchPolicy="no-cache"
              >
                {({
                  loading: loadingPrevisionnel,
                  error: errorPrevisionnel,
                  data: dataPrevisionnel = {},
                  refetch: refetchPrevisionnel
                }) => {
                  if (loadingPrevisionnel) return <Loader />;

                  const freq = data.getFrequences || [{}];
                  const previData = dataPrevisionnel.getPrevisionnel || [{}];

                  const lossData = prepareFrequenceDataByWeek(
                    data.getFrequences,
                    false
                  );

                  console.log({ lossData });

                  const tableau = (
                    <>
                      <TableFrequences data={previData} />
                    </>
                  );

                  return (
                    <>
                      <h2>Données brutes</h2>
                      <ul>
                        {freq.map(frequence => (
                          <li>
                            {frequence.fournisseur} de {frequence.montant} le{" "}
                            {moment.utc(frequence.date).format("llll")}
                          </li>
                        ))}
                      </ul>
                      <h2>Tableau wip</h2>
                      {tableau}
                    </>
                  );
                }}
              </Query>
            );
          }}
        </Query>
      </WrappedUp>
    );
  }
}

export default DebugPage;
